$( $ => {
  const accordion = $( '.bs-column--sidebar-filter .bs-div__inner' );
  if( accordion.length ) {
    $( accordion ).find( 'p' ).click( function(){
      $( this ).closest( '.bs-div' ).toggleClass( 'bs-div--active' );
    } );
  }
} );
